import { faFilter } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDeviceFloppy, IconFilter, IconFilterOff, IconTrash, IconX } from "@tabler/icons-react";
import { useRef, useState } from "react";
import { Dropdown, Form, Modal, Nav } from "react-bootstrap";
import Select, { components } from "react-select";
import { usePostRequest } from "../Utils/hooks/QueryHandler";
import useLocalStorageState from "use-local-storage-state";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { PostRequest } from "../Utils/hooks/ApiHandler";
import { toast } from "sonner";
import { customStyles } from "../Utils/helpers/commonhelper";
import { useOutsideClickHandler } from "../Utils/hooks/useOutsideClickHandler";
import { SubmitBtn } from "./Buttons/SubmitBtn";
import { CancelBtn } from "./Buttons/CancelBtn";
import { useGlobalState } from "../Utils/hooks/useFilterQueryValue";

const filterSchema = z.object({
    filterName: z.string().min(1, "Filter Name is required"),
    filterDescription: z.string().optional(),
});

export const Filter = ({
    dropdownOptions,
    pipelineId,
    filterState,
    setFilterState,
    filterDropdown,
    setFilterDropdown,
    setHeading,
    subFilter,
    customSubFilter,
    setTempFilterData,
    setCurrAdvFilter,
    filterEndpoint,
    module_name,
    canEdit_canDownload,
    view,
    setOffset,
    setCustomFilter,
    storageKey,
    metadata,
    filterQueryKey
}) => {
    const filterRefs = useRef({});
    const navigate = useNavigate();
    const [customer, setCustomer] = useLocalStorageState('customer');
    const headers = {
        Authorization: customer?.token?.authorization,
        Authentication: customer?.token?.authentication,
    }
    const [saveAsModal, setShowSaveAsModal] = useState(false)
    const cardName = `All ${module_name} - Copy`

    // loading state for submission of form
    const [loading, setLoading] = useState(false)

    // empty value deetection state to check before user do save as
    const [filterValueErrors, setFilterValueErrors] = useState({}) // New state for input value errors
    // Initialize react-hook-form for the modal
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        watch
    } = useForm({
        resolver: zodResolver(filterSchema)
    })

    const filterDropRef = useRef(null)
    // outside click useeffect for gear dropdown filter
    useOutsideClickHandler({
        objRef: filterDropRef,
        isDropdown: filterDropdown,
        setDropdown: setFilterDropdown
    })

    const DropdownIndicator = (props) => {
        return (
            <components.DropdownIndicator {...props}>
                <i
                    className="fa-solid fa-plus"
                    style={{
                        color: "white",
                        backgroundColor: "#7a3a5e",
                        padding: "5px",
                        borderRadius: "4px",
                        cursor: "pointer",
                        border: 0,
                        outline: 0,
                    }}
                ></i>
            </components.DropdownIndicator>
        );
    };

    const handleAddFilter = (option) => {
        const existingFilter = filterState.find((f) => f.field === option.value);

        if (existingFilter) {
            // Scroll to existing filter if it's already added
            filterRefs.current[existingFilter.id]?.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
            });
            return;
        }

        // let mappedOption = null

        // if (["owner_id", "visible_to", "approve_by"].includes(option.value)) {
        //     mappedOption = option.option?.map((opt) => ({
        //         value: opt.leadId,
        //         label: opt.leadName
        //     }))
        // } else if (option.value === "lead_source_id") {
        //     mappedOption = option.option?.map((opt) => ({
        //         value: opt.lead_source_id,
        //         label: opt.source_title
        //     }))
        // } else if (option.value === "company_id") {
        //     mappedOption = option.option?.map((opt) => ({
        //         value: opt.company_id,
        //         label: opt.company_name
        //     }))
        // } else if (option.value === "country") {
        //     mappedOption = option.option?.map((opt) => ({
        //         value: opt.countryId,
        //         label: opt.countryName
        //     }))
        // } else if (option.value === "state") {
        //     mappedOption = option.option?.map((opt) => ({
        //         value: opt.stateCode,
        //         label: opt.stateName
        //     }))
        // } else if (option.value === "city") {
        //     mappedOption = option.option?.map((opt) => ({
        //         value: opt.cityId,
        //         label: opt.cityName
        //     }))
        // } else if (option.value === "industry") {
        //     mappedOption = option.option?.map((opt) => ({
        //         value: opt.value,
        //         label: opt.label
        //     }))
        // } else if (option.value === "business_type") {
        //     mappedOption = option.option?.map((opt) => ({
        //         value: opt.value,
        //         label: opt.label
        //     }))
        // } else if (option.value === "employee_size") {
        //     mappedOption = option.option?.map((opt) => ({
        //         value: opt.value,
        //         label: opt.label
        //     }))
        // } else if (option.value === "deal_id") {
        //     mappedOption = option.option?.map((opt) => ({
        //         value: opt.id,
        //         label: opt.deal
        //     }))
        // } else if (option.value === "quotation_number") {
        //     mappedOption = option.option?.map((opt) => ({
        //         value: opt.id,
        //         label: opt.quotation_number
        //     }))
        // } else if (option.value === "contact_id") {
        //     mappedOption = option.option?.map((opt) => ({
        //         value: opt.contactId,
        //         label: opt.contact_name
        //     }))
        // } else if (option.value === "pipeline_stage_id") {
        //     mappedOption = option.option?.map((opt) => ({
        //         value: opt.stage_id,
        //         label: opt.stage_name
        //     }))
        // } else if (option.value === "lead_status") {
        //     mappedOption = option.option?.map((opt) => ({
        //         value: opt.value,
        //         label: opt.label
        //     }))
        // }

        // Add new filter
        const newFilter = {
            id: option.value, // Generate a unique ID for the filter row
            field: option.value,
            label_name: option.label,
            option: option.option ? option.option : null,
            subFilterType: option.type === "date-range" ? "between" : "equals", // Default sub-filter value
            value: "",
            type: option.type || null
        };
        setFilterState((prev) => [...prev, newFilter]);
        // Clear any existing value errors when a new filter is added
        setFilterValueErrors({});
    };

    const getFilterOptions = (filter) => {
        if (filter.id === "visible_to" ||
            filter.id === "company_id" ||
            filter.id === "owner_id" ||
            filter.id === "lead_source_id" ||
            filter.id === "deal_id" ||
            filter.id === "contact_id") {
            return customSubFilter
        } else if (filter.subFilterType !== "between") {
            return subFilter.filter((c) => c.value !== "between")
        }
        return subFilter
    }
    // to remove a particular field from the array
    const handleRemoveFilter = (id) => {
        if (filterState.length === 1) {
            setFilterState([]);
            setTempFilterData(null);
            setFilterValueErrors((prev) => {
                const newErrors = { ...prev };
                delete newErrors[id];
                return newErrors;
            });
            return
        }
        setFilterState((prev) => prev.filter((filter) => filter.id !== id));

        // setTempFilterData(null)
        // Remove error for the deleted filter
        setFilterValueErrors((prev) => {
            const newErrors = { ...prev };
            delete newErrors[id];
            return newErrors;
        });
    };

    // to change the subfilter value with respect to the particular field determined by its id
    const handleSubFilterChange = (id, selectedOption) => {
        setFilterState((prev) =>
            prev.map((filter) =>
                filter.id === id
                    ? { ...filter, subFilterType: selectedOption.value }
                    : filter
            )
        );
    };

    // adding new fields to the array.
    const handleValueChange = (id, newValue) => {
        setFilterState((prev) =>
            prev.map((filter) =>
                filter.id === id ? { ...filter, value: newValue } : filter
            )
        );
        // Clear error for this specific input when its value changes
        setFilterValueErrors((prev) => {
            const newErrors = { ...prev };
            delete newErrors[id];
            return newErrors;
        });
    };

    // New function to validate all filter input values
    const validateAllFilterValues = () => {
        const newErrors = {};
        let isValid = true;

        filterState.forEach((filter) => {
            if (["is_empty", "is_not_empty"].includes(filter.subFilterType)) return;

            if (typeof filter.value === "string") {
                if (filter.value?.trim() === "") {
                    newErrors[filter.id] = "This field is required";
                    isValid = false;
                }
                return;
            }

            if (typeof filter.value === "object") {
                if (!filter.value?.start || !filter.value?.end) {
                    newErrors[filter.id] = "Please select both dates";
                    isValid = false;
                }
                return;
            }
        });

        setFilterValueErrors(newErrors);
        return isValid;
    };

    const [filterQuerValue, setFilterQueryValue] = useGlobalState(filterQueryKey, {})

    // apply api would be called within this
    const handleApply = async () => {
        if (filterState?.length === 0) {
            setTempFilterData(null);
            return;
        }
        if (!validateAllFilterValues()) {
            return;
        }
        const applyData = []
        filterState.map((f) => {
            const data = {
                label_name: f.field,
                label_query: f.subFilterType,
                label_value:
                    f.subFilterType === "between"
                        ? { start: f.value?.start, end: f.value?.end }
                        : f.value,
            }
            applyData.push(data)
        })
        setFilterQueryValue({
            filter_values: applyData,
            filter_state: filterState
        })
        const applyPayload = {
            customer_id: customer.customer_details?.customer_id,
            filter_values: applyData,
            user_type: customer.customer_details?.user_type,
            user_login_id: customer.customer_details?.id,
            pipeline_id: pipelineId || null,
            view: view
        }
        // const res = await PostRequest(applyQuery, applyPayload, false, { headers }, { customer, setCustomer, rf: headers.Authentication, navigate })
        // if (res.success === false) {
        //     toast.error(res.message)
        //     return
        // }
        // setTempFilterData(res && res)
        setFilterDropdown(false)
        setOffset && setOffset(0)
    };

    // // for now i am directly calling functions within select for "save" but here i am including the handle function for the further api calling as well
    // const handleSave = () => {
    //     const updateFilterData = []
    //     filterState.map((f) => {
    //         const data = {
    //             label_name: f.field,
    //             label_query: f.subFilterType,
    //             label_value: f.value
    //         }
    //         updateFilterData.push(data)
    //     })

    //     const finalSaveData = {
    //         customer_id: customer.customer_details?.customer_id,
    //         filter_id: "1",
    //         card_name: cardName,
    //         filter_values: updateFilterData,
    //         user_login_id: customer.customer_details?.id
    //     }
    // }

    // save as api mutate function and calling
    const { mutate } = usePostRequest(filterEndpoint, false, { headers }, { customer, setCustomer, rf: headers.Authentication, navigate },)
    const onSubmit = (formData) => {
        setLoading(true)
        const filterData = []
        filterState.map((f) => {
            const data = {
                label_name: f.field,
                label_query: f.subFilterType,
                label_value: f.subFilterType === "between" ? [f.value["start"], f.value["end"]] : f.value
            }
            filterData.push(data)
        })

        const finalData = {
            customer_id: customer.customer_details?.customer_id,
            card_name:
                formData.filterName === cardName ? cardName : formData.filterName,
            description: formData.filterDescription,
            filter_values: filterData,
            user_login_id: customer.customer_details?.id,
            module_name: module_name
        };

        setCurrAdvFilter("save_as")
        setFilterQueryValue({
            filter_values: filterData,
            filter_state: filterState
        })
        // within mutate if response is success then
        mutate(finalData, {
            onSuccess: (data) => {
                if (data.status === "fail") {
                    toast.error(data.message)
                    setLoading(false)
                    return
                }
                if (data.status === "error") {
                    setLoading(false)
                    return
                }
                // to save the current created card name to identify irrespective of the page we are on, ( this was added to avoid issues such as filtercategories not containing the data available on 2 or 3 ... page)
                setCustomFilter(prev => ({ card_name: formData.filterName, id: data.data }))
                localStorage.setItem(storageKey, JSON.stringify({
                    ...metadata,
                    filterType: {
                        filterName: formData.filterName,
                        id: data.data
                    }
                }))
                reset();
                setHeading && setHeading(formData.filterName === cardName ? cardName : formData.filterName,)
                setFilterState([])
                setTempFilterData(null)
                // also you need to make sure that the top heading gets changed and the data received here would be passed up to the parent component where it would pass the data to the editcontact.
                setShowSaveAsModal(false)
                setLoading(false)
                setFilterDropdown(false)
                toast.success(data.message)
            }
        })
    }


    return (
        <Dropdown
            show={filterDropdown}
            as="div"
            ref={filterDropRef}
            autoClose={false}
            className="dropdownsWithoutToggle"
        >
            <Dropdown.Toggle
                onClick={() => setFilterDropdown(!filterDropdown)}
                as={Nav.Link}
                className="header-link p-0"
            >

                <button
                    className={`py-2 w-[30px] d-flex gap-1 rounded-1 justify-content-center ${filterState?.length > 0 ? "btn-default" : "btn-default-outline"}`}
                    style={{
                        fontSize: "1rem",
                        alignItems: "center",
                        height: "35px",
                        width: "2.5rem",
                        cursor: "pointer",
                    }}
                >
                    {" "}
                    <FontAwesomeIcon
                        style={{
                            width: "15px",
                            height: "15px",
                            // background: filterState?.length > 0 && "#7a3a5e",
                            // color: filterState?.length > 0 && "white"
                        }}
                        icon={faFilter}
                    />
                </button>
            </Dropdown.Toggle>

            <Dropdown.Menu
                className="defaultDropdownLong shadow-lg border-0 rounded-3 overflow-hidden dropdown-menu-end"
                style={{ right: "0", top: "10px", width: "350px", padding: 0, zIndex: 2000 }}
            >
                {/* Professional Header */}
                <div className="px-3 pt-3 pb-2 bg-light border-bottom">
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center gap-2">
                            <div
                                className="d-flex align-items-center justify-content-center rounded-2"
                                style={{
                                    background: "linear-gradient(135deg, #7a3a5e 0%, #4f243c 100%)",
                                    width: "34px",
                                    height: "34px",
                                    boxShadow: "0 4px 10px rgba(122, 58, 94, 0.2)"
                                }}
                            >
                                <IconFilter size={16} color="white" />
                            </div>
                            <span className="fw-bold text-dark" style={{ fontSize: "14px", textTransform: "capitalize" }}>
                                Filter {module_name?.split("_").join(" ")}
                            </span>
                        </div>
                        <button
                            className="btn btn-sm p-0 d-flex align-items-center justify-content-center"
                            onClick={() => setFilterDropdown(false)}
                            style={{ width: "24px", height: "24px", color: "#9ca3af" }}
                        >
                            <IconX size={18} />
                        </button>
                    </div>
                </div>

                {/* Search/Add Input Area */}
                <div className="p-3 bg-white border-bottom">
                    <label className="small fw-semibold text-secondary mb-2" style={{ fontSize: '10px' }}>
                        Add New Property
                    </label>
                    <Select
                        placeholder="Search attributes..."
                        // classNamePrefix="react-select"
                        isSearchable
                        onChange={handleAddFilter}
                        options={dropdownOptions}
                        components={{ DropdownIndicator }}
                        styles={{
                            ...customStyles,
                            control: (base) => ({
                                ...base,
                                borderRadius: '6px',
                                border: '1px solid #e2e8f0',
                                minHeight: '38px',
                                boxShadow: 'none',
                                '&:hover': { border: '1px solid #7a3a5e' }
                            }),
                            placeholder: (base) => ({
                                ...base,
                                fontSize: '1rem',
                                marginRight: '20px'
                            })
                        }}
                        value={null}
                    />
                </div>

                {/* Filter List Section */}
                <div
                    className="bar"
                    style={{
                        height: "320px",
                        overflowY: "auto",
                        backgroundColor: "#fff"
                    }}
                >
                    {filterState?.length === 0 ? (
                        <div className="d-flex flex-column align-items-center justify-content-center h-100 text-muted">
                            <IconFilterOff size={32} stroke={1} className="mb-2 opacity-50" />
                            <p style={{ fontSize: "13px" }}>No filters applied yet.</p>
                        </div>
                    ) : (
                        filterState?.map((filter) => (
                            <div
                                key={filter.id}
                                ref={(el) => (filterRefs.current[filter.id] = el)}
                                className="px-3 py-3 border-bottom position-relative filter-item-row"
                            >
                                <div className="d-flex justify-content-between align-items-start mb-2">
                                    <h6 className="fw-bold mb-0" style={{ fontSize: "13px", color: "#4a5568", paddingTop: '0.25rem' }}>
                                        {filter.label_name}
                                    </h6>
                                    <button
                                        className="btn btn-sm p-1 text-danger opacity-75 hover-opacity-100"
                                        onClick={() => handleRemoveFilter(filter.id)}
                                        style={{ border: 0, background: 'transparent' }}
                                    >
                                        <IconTrash size={14} />
                                    </button>
                                </div>

                                {/* Logic-based Selects and Inputs (Kept original logic) */}
                                <div className="d-flex flex-column gap-2">
                                    <Select
                                        // classNamePrefix="react-select"
                                        onChange={(option) => handleSubFilterChange(filter.id, option)}
                                        options={getFilterOptions(filter)}
                                        value={subFilter?.find((option) => option.value === filter.subFilterType)}
                                        isDisabled={filter.subFilterType === "between"}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            control: (base) => ({ ...base, minHeight: '32px', fontSize: '13px', borderRadius: '4px' }),
                                            menuPortal: base => ({ ...base, zIndex: 9999 }),
                                        }}
                                    />

                                    {/* Value Input Logic */}
                                    {filter.option === null ? (
                                        filter.subFilterType !== "between" ? (
                                            !["is_empty", "is_not_empty"].includes(filter.subFilterType) && (
                                                <input
                                                    value={filter.value}
                                                    onChange={(e) => handleValueChange(filter.id, e.target.value)}
                                                    type="text"
                                                    className={`form-control form-control-sm ${filterValueErrors[filter.id] ? "is-invalid" : ""}`}
                                                    placeholder="Enter Value"
                                                    style={{ fontSize: '13px' }}
                                                />
                                            )
                                        ) : (
                                            <div className="d-flex gap-2">
                                                <input
                                                    type="date"
                                                    className="form-control form-control-sm"
                                                    value={filter.value?.start || ""}
                                                    onChange={(e) => handleValueChange(filter.id, { ...filter.value, start: e.target.value })}
                                                />
                                                <input
                                                    type="date"
                                                    className="form-control form-control-sm"
                                                    value={filter.value?.end || ""}
                                                    onChange={(e) => handleValueChange(filter.id, { ...filter.value, end: e.target.value })}
                                                />
                                            </div>
                                        )
                                    ) : (
                                        <Select
                                            // classNamePrefix="react-select"
                                            onChange={(selectedOption) => handleValueChange(filter.id, selectedOption ? selectedOption.value : "")}
                                            options={filter.option}
                                            value={filter.option?.find((opt) => opt.value === filter.value)}
                                            menuPortalTarget={document.body}
                                            styles={{
                                                control: (base) => ({ ...base, minHeight: '32px', fontSize: '13px', borderRadius: '4px' }),
                                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                                            }}
                                        />
                                    )}
                                </div>
                            </div>
                        ))
                    )}
                </div>

                {/* Footer Actions */}
                <div className="p-3 bg-light border-top d-flex justify-content-between align-items-center">
                    <button
                        onClick={() => {
                            setFilterState([]);
                            setFilterQueryValue({ filter_values: [], filter_state: [] })
                            setCurrAdvFilter(null)
                            setTempFilterData(null);
                        }}
                        className="btn btn-link btn-sm text-decoration-none p-0"
                        style={{ color: "#7a3a5e", fontSize: "13px", fontWeight: "500" }}
                    >
                        Clear All
                    </button>

                    <div className="d-flex gap-2">
                        <button
                            onClick={() => {
                                if (!validateAllFilterValues()) return;
                                if (!canEdit_canDownload) {
                                    toast.warning("You are not a shared pipeline user. You are not authorized for this action!")
                                    return;
                                }
                                setShowSaveAsModal(true);
                            }}
                            disabled={filterState?.length === 0}
                            className="btn btn-default-outline py-1 px-3"
                            style={{ fontSize: "13px", borderRadius: "6px" }}
                        >
                            Save As
                        </button>
                        <button
                            onClick={() => {
                                setCurrAdvFilter('apply')
                                handleApply()
                            }}
                            disabled={filterState?.length === 0}
                            className="btn btn-default shadow-sm py-1 px-4"
                            style={{
                                backgroundColor: "#7a3a5e",
                                color: "white",
                                fontSize: "13px",
                                borderRadius: "6px",
                                opacity: filterState?.length === 0 ? 0.6 : 1
                            }}
                        >
                            Apply Filters
                        </button>
                    </div>
                </div>
            </Dropdown.Menu>
            {
                saveAsModal && filterState?.length > 0 && (
                    <Modal
                        style={{ zIndex: 9999 }}
                        show={setShowSaveAsModal}
                        onHide={() => setShowSaveAsModal(false)}
                        contentClassName="border-0 shadow-lg rounded-3"
                    >
                        {/* Consistent Professional Header */}
                        <Modal.Header closeButton className="border-bottom-0 pt-4 px-4 align-items-start">
                            <div className="d-flex flex-column">
                                <div className="d-flex align-items-start mb-1 gap-2">
                                    <div
                                        className="d-flex align-items-center justify-content-center rounded-2"
                                        style={{
                                            background: "linear-gradient(135deg, #7a3a5e 0%, #4f243c 100%)",
                                            width: "38px",
                                            height: "38px",
                                            boxShadow: "0 4px 10px rgba(122, 58, 94, 0.2)"
                                        }}
                                    >
                                        <IconDeviceFloppy stroke={2} size={20} color={"white"} />
                                    </div>
                                    <div className="d-flex flex-column">
                                        <Modal.Title className="h5 fw-bold m-0" style={{ color: '#1a202c' }}>
                                            Save Custom Filter
                                        </Modal.Title>
                                        <small className="text-muted">
                                            Give your filter a name for quick access later.
                                        </small>
                                    </div>
                                </div>

                            </div>
                        </Modal.Header>

                        <Modal.Body className="px-4 py-3">
                            <Form className="form-container" onSubmit={handleSubmit(onSubmit)}>
                                <Form.Group className="mb-4 focus-z-index position-relative " controlId="filterName">
                                    <Form.Label className="small fw-semibold text-secondary " style={{ fontSize: '11px', }}>
                                        Filter Name <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        style={{
                                            textTransform: "capitalize",
                                            fontSize: '14px',
                                            padding: '10px 12px',
                                            borderRadius: '6px',
                                            borderColor: '#dee2e6'
                                        }}
                                        type="text"
                                        defaultValue={cardName?.split("_")?.join(" ")}
                                        placeholder="e.g. High Priority Leads"
                                        {...register("filterName")}
                                        isInvalid={!!errors.filterName}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.filterName?.message}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className="mb-3 position-relative focus-z-index" controlId="filterDescription">
                                    <Form.Label className="small fw-semibold text-secondary " style={{ fontSize: '11px', }}>
                                        Description <span className="text-muted fw-normal">(Optional)</span>
                                    </Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        style={{
                                            fontSize: '14px',
                                            borderRadius: '6px',
                                            borderColor: '#dee2e6',
                                            resize: 'none'
                                        }}
                                        placeholder="Briefly describe what this filter captures..."
                                        {...register("filterDescription")}
                                    />
                                </Form.Group>

                                {/* Custom Styled Footer inside Form */}
                                <div className="d-flex justify-content-end gap-2 mt-4 pt-2 pb-2">
                                    <CancelBtn
                                        type={'button'}
                                        onClick={() => setShowSaveAsModal(false)}
                                        submitClicked={loading}
                                    />

                                    <SubmitBtn
                                        type={'submit'}
                                        loading={loading}
                                        title={"Save Filter"}
                                    />
                                </div>
                            </Form>
                        </Modal.Body>
                    </Modal>
                )
            }
        </Dropdown >
    );
}
